import React from 'react';
import { Post, useNewsQuery } from '@framework/news/get-news';
import { Card, CardContent } from '@components/ui/card';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import SectionHeader from '@components/common/section-header';
import HomepageNewsLoader from '@components/ui-old/loaders/homepage-news-loader';
import Divider from '@components/ui-old/divider';
function formatDate(dateString: string, locale: string) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(date);
}
const HomepageNews: React.FC = () => {
  const {
    data,
    isLoading,
    error
  } = useNewsQuery();
  const router = useRouter();
  const {
    locale
  } = router;
  if (isLoading) {
    return <HomepageNewsLoader count={3} />;
  }
  if (error) {
    return <p className="text-red-500"></p>;
  }
  if (!data?.results || data.results.length === 0) {
    return null;
  }
  const latestNews = data.results.slice(0, 3);
  const placeholderImage = '/assets/images/forever-placeholder.jpg';
  return <>
      <SectionHeader sectionHeading="text-news" className="my-6" textClassName="text-2xl" data-sentry-element="SectionHeader" data-sentry-source-file="homepage-news.tsx" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
        {latestNews.map((post: Post) => <Link key={post.id} href={`/news/${post.id}`} className="block">
            <Card className="flex flex-col h-full overflow-hidden rounded-3xl border
                         dark:border-neutral-800 w-full bg-white dark:bg-neutral-800
                         hover:scale-105 transition duration-200 cursor-pointer">
              <Image src={post.image || placeholderImage} alt={post.title} width={800} height={800} className="w-full h-[250px] sm:h-[350px] object-cover object-center" placeholder="blur" blurDataURL={placeholderImage} />
              <CardContent className="flex flex-col flex-grow p-4 sm:p-6">
                <p className="text-xs text-neutral-600 dark:text-neutral-200 mb-2">
                  {formatDate(post.publicationDate, locale || '')}
                </p>
                <h2 className="text-base font-semibold truncate">{post.title}</h2>
                <p className="text-sm text-neutral-600 dark:text-neutral-200 mt-2 line-clamp-3">{post.summary}</p>
              </CardContent>
            </Card>
          </Link>)}
      </div>
      <Divider data-sentry-element="Divider" data-sentry-source-file="homepage-news.tsx" />
    </>;
};
export default HomepageNews;